<template>
  <div class="container py-8">
    <!-- <div class="breadcrumbs flex flex-wrap py-4 uppercase">
      <p>{{ $t('team') }}:</p>

      <p class="font-semibold">{{ $t('expert_team') }}</p>
      <nuxt-link :to="localePath('team-management')"
        >{{ $t('management') }}
      </nuxt-link>
      <nuxt-link :to="localePath('team-associates')"
        >{{ $t('external_associates') }}
      </nuxt-link>
    </div> -->
    <div class="max-w-md">
      <div
        v-for="group of Object.keys(members)"
        :key="group"
        class="flex text-lg mb-4 justify-between"
      >
        <h2 class="font-semibold w-1/2">{{ $t(group) }}:</h2>
        <div class="w-1/2">
          <h3 v-for="member of members[group]" :key="member.name" class="block">
            {{ member.name }}
          </h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import members from '~/static/json/members.json'

export default {
  data() {
    return {
      members
    }
  }
}
</script>

<style scoped>
.project-thumb {
  height: 250px;
  position: relative;
  overflow: hidden;
  cursor: hover;
}
.project-thumb img {
  width: 100%;
  height: 250px;
  object-fit: cover;
  cursor: hover;
}
/* .project:nth-child(odd) .project-info {
  background-color: rgba(255, 191, 0, 0.75);
  color: white;
  border-top: none;
} */
.project-thumb:hover .project-info {
  opacity: 1;
}
.project-thumb:hover h3 {
  /* animation: tracking-in-expand-fwd-top 0.8s cubic-bezier(0.215, 0.61, 0.355, 1)
    both; */
}
.project-thumb:hover img {
  transition: 0.2s;
  transform: scale(1.4);
}
.project-info {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 10px;
  transition: 0.3s;
  border-top: 3px solid black;
  cursor: hover;
}

.project-info h3 {
  font-weight: 600;
  font-size: 24px;
}
</style>
